module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('h1', {
    staticClass: "chapter-number---IVP sigil_not_in_toc"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page9",
      "title": "9"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "chapter-title---IVP",
    attrs: {
      "id": "_idParaDest-2"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor001"
    }
  }), _vm._v("Preface and Acknowledgments")]), _vm._v(" "), _c('p', {
    staticClass: "veryfirst"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("W")]), _vm._v("orship in the way of the cross involves restructuring, reimagining, and renewing the world both in the image of the God who is love and through the embodiment of love by God’s people, the church. For the better part of the past decade I have been studying this concept in the Bible and in the writings of theologians of the church through the ages. Experiencing the truth of this theology in real life in the church is, however, a more recent event. In fact, my experience with the church, like the experience of many others, has been a mixed bag of joy and frustration. In what can only be described as the extreme, providential irony of God, I write this preface to a book that exalts the church as the means by which the world encounters the transforming love of Jesus Christ after having come out of a season of a schism in leadership in what proved to be a really unhealthy and soul-crushing church situation. I’m now in the midst of beginning a new work with a group of friends, which I hope will embody the reconciling and redemptive love of God in Jesus Christ to all people.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("I share this because it is part of my story. It is important for me to be “on the level” with you, the reader, as I write what could appear to be an idealistic treatise of hope and wonder at what the church is and what the church can become through God’s gracious provision and spiritual power. I believe in the transformative power of Christ’s love and presence through the church to a certain extent in spite of—not because of—many of my past experiences in the church. In all of my church experiences (even my most recent, negative experience), there have been glimpses of redemptive beauty. This is so even while dealing with the persistent irritation of ecclesially inflicted wounds resulting from problems in some churches to which I have belonged.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page10",
      "title": "10"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor002"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor003"
    }
  }), _vm._v("My experience at Park Street Church in Boston stands out as the tipping point for me where a specific theology of the church, the church as the worshiping community in which Christ’s transformative presence resides through his people, became more than an abstract idea but a tangible, lived reality. Without idealizing my brief experience at Park Street, I will say that it was the first place I fully experienced the theology I had studied about and dreamed about. My time there was so profoundly life-giving and spiritually refreshing. It took me two years to really let go of my vital connection to that church after moving twenty-six hundred miles across the country to take up my current post as an assistant professor. There were other churches along the way that contributed to the lived experience of the love of Christ in the church. Some of these (but not all) also weaved those glimpses of hope with theological ideas and an ecclesial praxis that virtually crushed my faith in the gospel.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Yet here is the profound paradox: the burden-bearing of the church is—as Paul discusses in his epistles—the means by which we embody the love of Christ; in and through his loving community, the church, we have the potential to become like the God who is love. Thus even the church in its imperfection (including my negative experiences, while definitely regrettable and unfortunate) does not negate a theology of the primacy and importance of the church; rather, it validates it! If bearing the burden of the other were an easy task, it would not actually be a burden to bear. Even the most diligent, loving church communities will fall short. Yet this is not only a picture of the inevitability of sin; it is the means by which God, through our love for the other and our experience of being loved by the other, transforms us into the others-centered, self-giving image of his divine love. The enactment and reception of this burden-bearing love is the way we become like the God whose love is displayed, unveiled, explicated, and experienced in the cross of Jesus Christ. In other words, we experience a growth in Christlike character through the community of Christ’s love, the church, which results in our spiritual transformation into the perfect image of God’s love. It is toward this task that God calls us so that we might be a people who—by embodying his love—become reconciled reconcilers and agents of his love and peace in this beautiful, terrible world."), _c('a', {
    attrs: {
      "id": "_idTextAnchor004"
    }
  }), _c('span', {
    attrs: {
      "href": "#/Text/notes#_idTextAnchor870",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "notesbodyref"
  }, [_vm._v("1")])])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page11",
      "title": "11"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor005"
    }
  }), _vm._v("As we begin, I wish to extend thanks and genuine appreciation to a host of people who, through their support and friendship along the way, have helped this book come into existence. The pride of place goes to my wife, Tara, who has faithfully traveled with me through many career paths and across many continents as my deepest companion and most genuine, beloved confidant. Without her resolve we would never have stayed the course to finish my doctoral studies in Scotland. I received several job offers in other fields while studying abroad, but because of her strength of character and her perseverance of spirit, I was convinced that staying and finishing the course was the right thing to do. Without her, I would have convinced myself that doing a PhD was crazy (which it is) and quit. I was so impressed at her ability to get a job so quickly in the UK, which was essentially what allowed us to keep from sinking financially during those doctoral years. Truly, this book would never have been parsed out if it weren’t for her work. The fact that we were and are a team made my work on this project possible. I also wish to apologize to her for making a habit during those years of hijacking our dinner conversations to talk about whatever incredibly boring theological minutiae I had recently discovered. Most of all, I am grateful for the warmth and authenticity of her soul. It is my greatest joy to enjoy the seemingly simple but deeply profound spiritual moments of life with her: listening to records, playing with Zoe and Liam, and enjoying a cup of coffee or a meal. To live life with the person I most admire and who reminds me most of the power of selfless, self-giving love is my greatest privilege and joy.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Thanks and love to my family: Carole, John D, Joel, Jackie, and to all of my extended family and relatives for your support of me, and for always supporting my musical and academic endeavors even when that included sitting through loud ska concerts and my phase as a raging, immature Bible thumper. Special thanks to Auntie Diana (AKA “Tia”) for her presence, love, and support for Tara, the kids, and me. Your hospitality and humility is a source of familial warmth and Christlike encouragement to us.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("I am grateful to Matthew Kruse at Seven Mile Road church for his personal mentoring and his support of my seminary education during some crucial early years of my faith. Likewise, the early influence of Msgr. Paul Garrity, Fr. Tim Kearney, and Fr. Mike Ferraro provided pastoral and "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page12",
      "title": "12"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor006"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor007"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor008"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor009"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor010"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor011"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor012"
    }
  }), _vm._v("formative experiences that instilled in me a love for social justice ministries and the liturgical Great Tradition of the church. I’m incredibly thankful to Rev. Roger Nelson for his friendship, for his support for the local music scene in Boston, and for his ministry during his time at St. John’s Episcopal Church in Saugus, Massachusetts."), _c('b', {
    staticClass: "b"
  }), _vm._v("I am glad that I had the opportunity to work at Park Street Church in Boston with the entire staff and congregation, especially Gordon Hugenberger, Walter Kim, and Damon Addleman. Among my Anglican brothers and sisters, I am grateful for the spiritual guidance of Bishop William Murdoch and for the early mentoring of Fr. Sam Schutz. All of the clergy, congregations, and people of the Anglican Diocese in New England hold a special place in my story and heart. I’m very grateful to T. C. Moore and Chris Llewellyn for their contributions to this book.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("In the world of the academy, many thanks go to Dr. Grant Macaskill, who supervised my PhD thesis at the University of St. Andrews. Thanks as well to N. T. Wright, Mark Elliot, and Scott Hafemann for giving me the privilege of coediting a book ("), _c('i', {
    staticClass: "i"
  }, [_vm._v("Galatians and Christian Theology")]), _vm._v(") with such luminaries. I would be remiss if I didn’t directly thank Dr. Michael Gorman, who I consider to be one of the great Pauline scholars of the church. Dr. Gorman was kind enough to read my entire PhD thesis and to offer extended, valuable feedback. His work on cruciformity has been highly influential on me and on many others, and I hope that the present work contributes something to the conversation in which he is the leading voice.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Thanks go as well to Dr. Jason Hiles, Anna Faith Smith, and the faculty of the College of Theology at Grand Canyon University and Grand Canyon Theological Seminary. Special thanks and appreciation are due my friends, colleagues, and students in the Center for Worship Arts and the GCU College of Theology. I greatly appreciate the catalytic and creative foundational work of Scott Fehrenbacher and Bart Millard. Likewise, I’m grateful for the collegiality, collaborative spirit, and expert skill of my colleagues Eric Johnson and John McJunkin in the GCU Recording Studio, Mark Huggins in the College of Fine Arts and Production, and my friend and colleague Jonathan Sharpe, and my friend and colleague Jonathan Sharpe. Your support across the board has helped to encourage "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page13",
      "title": "13"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor013"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor014"
    }
  }), _vm._v("me, to shape my thought, and to refine my theology. Of course, any mistakes or missteps that remain in this book belong solely to me.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Last, I am sincerely thankful to the editorial team and the entire staff at InterVarsity Press. Special thanks go to the editors of this book whose feedback has been substantive and very helpful. In particular, I would like to thank Al Hsu for providing not only a wonderful and efficient editorial experience but also an educational experience. His editorial insights and direction have no doubt helped me to grow as a writer, and I am very grateful for his commitment to this project.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("As we begin, let us reflect and pray together about the glory of the triune God: Father, Son, and Holy Spirit, by contemplatively praying this ancient prayer of the church:")]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "verse"
  }, [_c('b', {
    staticClass: "b"
  }, [_vm._v("“Glory to God (Gloria in excelsis)”")])]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_vm._v("Glory to God in the highest,")]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_vm._v("and peace to his people on earth.")]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_vm._v("Lord God, heavenly King,")]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_vm._v("almighty God and Father,")]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_vm._v("we worship you, we give you thanks,")]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_vm._v("we praise you for your glory.")]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_vm._v("Lord Jesus Christ, only Son of the Father,")]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_vm._v("Lord God, Lamb of God,")]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_vm._v("you take away the sin of the world:")]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_vm._v("have mercy on us;")]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_vm._v("you are seated at the right hand of the Father:")]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_vm._v("receive our prayer.")]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_vm._v("For you alone are the Holy One,")]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_vm._v("you alone are the Lord,")]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_vm._v("you alone are the Most High,")]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_vm._v("Jesus Christ,")]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_vm._v("with the Holy Spirit,")]), _vm._v(" "), _c('p', {
    staticClass: "verse"
  }, [_vm._v("in the glory of God the Father. Amen."), _c('a', {
    attrs: {
      "id": "_idTextAnchor015"
    }
  }), _c('span', {
    attrs: {
      "href": "#/Text/notes#_idTextAnchor871",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "notesbodyref"
  }, [_vm._v("2")])])])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page14",
      "title": "14"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page15",
      "title": "15"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0030b264","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/preface_ackn.vue
// module id = 66
// module chunks = 0